import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { ErrorBoundary } from './components/ErrorBoundary';
import { Toaster } from './components/ui/toaster';
import { setupErrorHandlers } from './utils/errorHandler';

// Setup error handlers (always — lightweight, no heavy imports)
setupErrorHandlers();

// Safety net: remove any legacy 'sb-' localStorage keys from the pre-Neon era.
// Safe to remove entirely once all users have visited at least once post-migration.
try {
  const keysToRemove = Object.keys(localStorage).filter(k => k.startsWith('sb-'));
  keysToRemove.forEach(k => localStorage.removeItem(k));
} catch {
  // localStorage unavailable (SSR or private browsing)
}

// Initialize telemetry asynchronously (keeps Sentry/Datadog out of main bundle)
import('./telemetry/native-telemetry').then(({ nativeTelemetry }) => {
  nativeTelemetry.initialize().catch(console.error);
});

// Conditionally initialize full monitoring stack
if (import.meta.env.VITE_ENABLE_FULL_MONITORING === 'true') {
  // PostHog analytics
  import('@/services/PostHogIntegrationService').then(({ postHogService }) => {
    postHogService.initialize().catch(console.error);
  });

  // UX Testing Service (auto-inits on import)
  import('@/services/UserExperienceTestingService');

  // Automated data aggregation (15-minute intervals)
  import('@/services/AutomatedDataAggregationService').then(({ automatedDataAggregation }) => {
    automatedDataAggregation.start();
  });

  // Self-Healing Orchestrator (auto-inits on import)
  import('@/agents/SelfHealingOrchestrator');

  // Loft Platform Integration (vCluster, DevPod)
  import('@/services/LoftPlatformService').then(({ loftPlatformService }) => {
    loftPlatformService.initialize().catch(console.error);
  });
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
      <Toaster />
    </ErrorBoundary>
  </React.StrictMode>
);
